import { get, post, patch } from '../libs/requestClient';

export const getAllOrders = () => get('/v1/orders');

export const getOrder = id => get(`/v1/orders/${id}`);

export const searchOrder = query => post('/v1/orders/search', { order_number: query });

export const updateOrder = (id, data) => patch(`/v1/orders/${id}`, data);
